import appClient from "../../common/services/AppClient";
import { endpoints } from "../../../config";

export type FollowUpProject = {
    id: string;
    name: string;
    defaultTaskTypeId: string | null;
    taskTypes: { id: string; name: string }[];
    assignees: { id: string; name: string }[];
};

export type FollowUpTaskOptions = {
    subjectId: string;
    caseLabel: string;
    subjectKind: string;
    titlePrefix: string;
    submissionId: string | null;
    uwYear: number | null;
    suggestedProjectId: string | null;
    projects: FollowUpProject[];
};

const url = (subjectId: string) =>
    `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/follow-up-tasks`;

export default class FollowUpTaskService {
    options(subjectId: string) {
        return appClient.get<FollowUpTaskOptions>(`${url(subjectId)}/options`);
    }

    create(subjectId: string, form: FormData) {
        return appClient.post<{ taskId: string }>(url(subjectId), form);
    }
}
